/**
 * Whether a link leaves the storefront and therefore has to be an ordinary anchor rather than a
 * router link: the router treats anything it is given as a path within the site, so an absolute
 * url handed to `Link` becomes `/https://example.com/` and goes nowhere.
 *
 * The schemes are a list rather than "anything before a colon", so that cms content cannot turn a
 * cta into a `javascript:` url the browser would run on click. `mailto:` and `tel:` belong to the
 * browser as much as http does, which is what the cms guidance for `Link` already tells editors,
 * and `//example.com` is another site on whatever scheme the page is served over. A path, with or
 * without a leading slash, is the router's - and so is anything else, where it can do no harm.
 */
export function isExternalUrl(link: string): boolean {
	return /^(?:(?:https?|mailto|tel):|\/\/)/i.test(link.trim());
}
